import React from 'react';
import {Navbar, Container, Nav, Form, NavDropdown} from "react-bootstrap";
import './main.scss';
import ww_logo from "../../images/logo/logogr.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";


function Navigation() {
    return (
        <div className="App">
            <header>
                <Container>
                    <Navbar expand="md">
                        <Navbar.Brand href="./"><img src={ww_logo} alt="Orb Explorer"/></Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarTog" ><FontAwesomeIcon icon={faBars} className="navToggle" /></Navbar.Toggle>
                        <Navbar.Collapse id="navbarTog">
                            <Form className="d-flex">
                                {/* <input type="search" id="search" name="search" placeholder="Search address, collection or request" size={50}/>
                                 <input type="submit" className="btn-grad" value="Search" /> */}
                            </Form>
                            <Nav className="ms-auto">
                                <Nav.Link href="/">My account</Nav.Link>
                                <Nav.Link href="/">About</Nav.Link>
                                <NavDropdown title="Browse created pages">
                                    <NavDropdown.Item href="/Request">Request certificate</NavDropdown.Item>
                                    <NavDropdown.Item href="/ViewCertificate">View certificate</NavDropdown.Item>
                                    <NavDropdown.Item href="/Browse">Browse certificates</NavDropdown.Item>
                                    <NavDropdown.Item href="/JudgeSpace">Judge Space</NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link href="#action5">Connect Wallet</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </Container>
            </header>
        </div>
    );
}

export default Navigation;
